const commentList = () => import('@/pages/community/comment/index.vue');
const commentDetail = () => import('@/pages/community/comment/detail.vue');

export default [{
    path: '/community/comment',
    component: commentList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '评论列表',
        activeRoute: '/community/comment'
    }]
}, {
    path: '/community/comment/detail',
    component: commentDetail,
    meta: [{
        name: '社区管理'
    }, {
        name: '评论列表',
        url: '/community/comment'
    }, {
        name: '评论详情',
        activeRoute: '/community/comment'
    }]
}];